module.exports = __webpack_public_path__ + "img/empty.ddf7db71.svg";